/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerPayment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.557 2h8.886l-1.807 4.819 3.255 4.063.027.043c.473.733.796 1.55.957 2.395l1.361.68H22v8h-4.847a22.45 22.45 0 0 1-1.957.481c-1.298.26-3.115.519-5.196.519h-.028l-.05-.001a7.35 7.35 0 0 1-.74-.072 9.796 9.796 0 0 1-1.899-.487c-1.526-.555-3.448-1.66-5.083-3.84a1 1 0 0 1 .352-1.494 5.674 5.674 0 0 1-.186-.452l-.001-.002c-.7-1.93-.357-4.063.717-5.727l.027-.043 3.255-4.063zM7.98 8l-3.244 4.05c-.748 1.186-.951 2.649-.491 3.92.143.39.305.668.467.835.14.145.263.195.415.195h2.716a7.572 7.572 0 0 1-.7-.986 9.783 9.783 0 0 1-1.118-2.791l-.004-.017V13.2l-.002-.004A1 1 0 0 1 7 12h6a.95.95 0 0 1 .249.032L10.019 8zm1.827-2 .75-2H7.443l.75 2zm2.957 8H8.366c.128.31.29.65.491.986C9.517 16.084 10.497 17 12 17a1 1 0 1 1 0 2H5.297a8.72 8.72 0 0 0 2.67 1.56 7.794 7.794 0 0 0 1.508.388 5.322 5.322 0 0 0 .512.052h.017c1.917 0 3.599-.24 4.8-.48A21.69 21.69 0 0 0 16 20.245v-4.628zM18 16v4h2v-4zm.414-9 1.293 1.293-1.414 1.414L14.586 6l3.707-3.707 1.414 1.414L18.414 5H22v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomerPayment as CustomerPayment };
